unable to read source [project]/momira.app/web/node_modules/src/state-manager.ts